import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100% - 50px);
  color: ${({ theme }) => theme.colors.lightGray};

  svg {
    fill: ${({ theme }) => theme.colors.lightGray};
    margin-bottom: 2rem;
  }

  span {
    text-align: center;
    font-size: 0.875rem;

    & + span {
      padding-top: 1rem;
    }
  }
`;
